import { styled, alpha } from "@mui/material/styles";
import { Box, Card, CardContent, Table, Button } from "@mui/material";

// Shared styled components
export const StyledTrainingCard = styled(Card)(({ theme }) => ({
  height: "auto",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
}));

export const TrainingHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const TrainingContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(3),
  paddingTop: theme.spacing(2),
}));

export const MetricTable = styled(Table)(({ theme }) => ({
  "& .MuiTableCell-root": {
    border: "none",
    padding: theme.spacing(1),
  },
  "& .MuiTableCell-head": {
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },
}));

export const ActionButton = styled(Button)(() => ({
  borderRadius: 20,
  padding: "8px 20px",
  textTransform: "none",
  fontWeight: 600,
}));

export const ExerciseCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1.5),
  backgroundColor: alpha(theme.palette.background.paper, 0.7),
  "&:hover": {
    backgroundColor: theme.palette.background.paper,
  },
}));

export const SetProgressRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1),
  margin: theme.spacing(0.5, 0),
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
}));
